export default "__VITE_ASSET__db08e5ca__"